import { CHAIN_ID } from "@mezo/sdk"
import {
  ArrowNarrowLeft,
  Block,
  Button,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { selectIsOnEthereumChain, useDappSelector } from "#/redux-state"
import { SDK_NETWORK } from "#/shared/constants"

import SwitchChainButton from "./SwitchChainButton"

export default function ReturnAssetButton({
  onClick,
  isDisabled,
  isProcessing = false,
  content = "Withdraw",
}: {
  onClick: () => void
  isDisabled?: boolean
  isProcessing?: boolean
  content?: string
}) {
  const hasCorrectChain = useDappSelector(selectIsOnEthereumChain)
  const [css] = useStyletron()

  if (!hasCorrectChain)
    return (
      <SwitchChainButton
        label={content.toLowerCase()}
        chainId={CHAIN_ID[SDK_NETWORK]}
      />
    )

  return (
    <Button
      // TODO: Replace with ArrowNarrowDownLeft icon
      startEnhancer={
        <Block className={css({ rotate: "-45deg" })}>
          <ArrowNarrowLeft size={16} />
        </Block>
      }
      onClick={onClick}
      disabled={isDisabled}
      shape="pill"
      size="small"
      kind="secondary"
      isLoading={isProcessing}
      overrides={{ BaseButton: { style: () => ({ minWidth: "max-content" }) } }}
    >
      {content}
    </Button>
  )
}
